/* Clients register tokens — Clients Screen Directive §15. Accent is a
   background only, never ink or stroke. No alpha status fills. */
export const T = {
  page: "#EDEAE3", card: "#FFFFFF", panel: "#FBFAF7", sunken: "#F6F4EF",
  inset: "#F4F2ED", pressed: "#E4E0D7",
  border: "#DAD5CA", control: "#C9C3B6", dividerInner: "#E6E2D9", dividerRow: "#F0EDE6",
  ink: "#1A1A1A", ink2: "#59554D", ink3: "#8A857A", muted: "#6B6660", disabled: "#B5AFA3",
  accent: "#FFD108", accentEdge: "#E0B800", accentTint: "#FFF8D6", accentWash: "#FFFCEF",
  accentInk: "#8A6D00", accentInkPage: "#6B5600", accentIcon: "#C9A400",
  destructive: "#8E1212", overdueSpine: "#FF4F00",
};

export const TONES = {
  success: { fill: "#E3F3E9", ink: "#0B4F2E", border: "#A9D9BE", dot: "#0E6B3F" },
  warning: { fill: "#FFF7D1", ink: "#6B5600", border: "#E8D48A", dot: "#E0B800" },
  overdue: { fill: "#FFE9E0", ink: "#9A3200", border: "#F3BFA8", dot: "#C23A00" },
  neutral: { fill: "#F1EEE6", ink: "#59554D", border: "#DAD5CA", dot: "#8A857A" },
  zero: { fill: "#FBFAF7", ink: "#8F8A7F", border: "#E2DED4", dot: "#B5AFA3" },
  pale: { fill: "#E4E0D7", ink: "#8F8A7F", border: "#DAD5CA", dot: "#B5AFA3" },
};

export const MANROPE = { fontFamily: "Manrope, sans-serif" };

/* Fixed product order (directive §10.3) */
export const PRODUCTS = [
  { key: "EA", name: "EQUIPR Allocate" }, { key: "EM", name: "EQUIPR Maintain" },
  { key: "EO", name: "EQUIPR Operator" }, { key: "EC", name: "EQUIPR Core" },
  { key: "EG", name: "EQUIPR Guardian" }, { key: "ER", name: "EQUIPR Remote" },
  { key: "EH", name: "EQUIPR Horizon" },
];

export const DENSITIES = [
  { key: "compact", label: "Compact", h: 38 },
  { key: "comfortable", label: "Comfortable", h: 50 },
  { key: "roomy", label: "Roomy", h: 60 },
];

export const GRID = "30px minmax(250px,1.5fr) 138px 72px 96px 112px 112px minmax(210px,1fr) 34px";

export const FOCUS = "focus-visible:outline-none focus-visible:border-[#1A1A1A] focus-visible:shadow-[0_0_0_3px_rgba(255,209,8,0.35)]";

export const ddmon = (iso) => {
  if (!iso) return null;
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const M = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${String(d.getDate()).padStart(2, "0")} ${M[d.getMonth()]} ${String(d.getFullYear()).slice(2)}`;
};

export const addDays = (iso, n) => {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};
